import { api } from "@/lib/api/client";

/** A routable contact group (queue) a member can address a request to. */
export interface ContactGroup {
  id: number;
  name: string;
  description: string;
}

export interface ContactMessage {
  id: number;
  role: "user" | "assistant" | "staff";
  /** Source of truth for "the AI wrote this". */
  is_ai: boolean;
  /** Attribution: "AI" when is_ai; else the human author's name; else "Anonymous". */
  author_name: string;
  /** Human author's user id (null for AI / removed authors). Lets the client tell
   *  "my own message" from a colleague's — both are role "user" on a ticket. */
  author_user_id: number | null;
  content: string;
  created_at: string;
}

export interface ContactConversation {
  id: number;
  created_at: string;
  status: string;
  category?: string | null;
  is_ticket: boolean;
  escalated_at?: string | null;
  /** Groups this conversation is routed to. */
  group_ids: number[];
  /** Conversation participants, owner-first; `name` = full name → email → "Anonymous". */
  participants: { id: number; name: string; role: string }[];
  history: ContactMessage[];
}

export interface CreateRequestPayload {
  group_ids: number[];
  category?: string;
  message: string;
}

export const contactApi = {
  getContactGroups: () => api.get<ContactGroup[]>("/support/contact-groups/"),

  createRequest: (data: CreateRequestPayload) =>
    api.post<ContactConversation>("/support/contact/", data),

  postMessage: (convId: number, message: string) =>
    api.post<ContactConversation>(`/support/conversations/${convId}/messages/`, { message }),

  escalate: (convId: number, group_ids: number[]) =>
    api.post<ContactConversation>(`/support/conversations/${convId}/escalate/`, { group_ids }),

  addParticipant: (convId: number, user_id: number) =>
    api.post<ContactConversation>(`/support/conversations/${convId}/participants/`, { user_id }),
};
